import { render } from "./other.vue?vue&type=template&id=b49213d6"
import script from "./other.vue?vue&type=script&lang=js"
export * from "./other.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/chooseLink/components/other.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b49213d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b49213d6', __exports__)) {
    console.log('reload')
    api.reload('b49213d6', __exports__)
  }
  
  module.hot.accept("./other.vue?vue&type=template&id=b49213d6", () => {
    console.log('re-render')
    api.rerender('b49213d6', render)
  })

}


export default __exports__